<div>
  <div nz-dropdown nzTrigger="click" class="dropdown" [nzDropdownMenu]="menu" (nzVisibleChange)="badgeCountIncrease()">
    <!-- <nz-badge [nzCount]="badgeCount"> -->
    <nz-avatar nzIcon="user" [nzShape]="'square'" [nzSize]="'default'" class="avatar"></nz-avatar>
    <!-- </nz-badge> -->
  </div>
  <nz-dropdown-menu #menu="nzDropdownMenu"> 
    <ul nz-menu>
      <li nz-menu-item>
        <strong>{{ 'topBar.profileMenu.hello' | translate }}, {{name || 'Anonymous'}}</strong>
        <!-- <div>
          <strong class="mr-1">
            {{ 'topBar.profileMenu.billingPlan' | translate }}:
          </strong>
          Professional
        </div> -->
        <div>
          <strong>
            {{ 'topBar.profileMenu.role' | translate }}:
          </strong>
          {{role || '—'}}
        </div>
      </li>
      <li nz-menu-divider></li>
      <li nz-menu-item>
        <div>
          <strong>{{ 'user' | translate }}: </strong>
          {{name || '—'}}
          <br>
          <strong>{{ 'topBar.profileMenu.email' | translate }}: </strong>
          {{email || '—'}}
          <br />

        </div>
      </li>
      <li nz-menu-divider></li>
      <li nz-menu-item>
        <a href="javascript: void(0);" (click)="navigateCompany()">
          <i class="fe fe-user mr-2"></i>
          {{ 'topBar.profileMenu.editProfile' | translate }}:
        </a>
      </li>

      <li nz-menu-item>
        <a href="javascript: void(0);" (click)="lock()">
          <i class="fe fe-lock mr-2"></i>
          Lock
        </a>
      </li>

      <li nz-menu-divider></li>
      <li nz-menu-item>

        <a href="javascript: void(0);" (click)="logout()">
          <i class="fe fe-log-out mr-2"></i>
          {{ 'topBar.profileMenu.logout' | translate }}:
        </a>
      </li>
    </ul>
  </nz-dropdown-menu>
</div>